const api = {
  GET_LIST_CLOSED_MERCHANT_CATEGORY:
    '/index.php?r=api/v1/closed_merchant_category/ref-closed-merchant-category/index',
  VIEW_CLOSED_MERCHANT_CATEGORY:
    '/index.php?r=api/v1/closed_merchant_category/ref-closed-merchant-category/view',
  CREATE_CLOSED_MERCHANT_CATEGORY:
    '/index.php?r=api/v1/closed_merchant_category/ref-closed-merchant-category/create',
  UPDATE_CLOSED_MERCHANT_CATEGORY:
    '/index.php?r=api/v1/closed_merchant_category/ref-closed-merchant-category/update',
};

export default api;
